<div class="request-main" [ngClass]="{'in-detail': isInDetail == true}">
    <request-header
            [filter]="filter"
            [users]="users"></request-header>
    <div class="request-list" *ngIf="users">
        <request-list [fullView]="!isInDetail" [filter]="filter" [userInfos]="users"></request-list>
    </div>
</div>

<div class="one-canvas" [ngClass]="{'show': isInDetail == true }" *ngIf="isInDetail">
    <router-outlet></router-outlet>
</div>
